<template>
    <section class="card">  
        <div class="d-flex align-items-center mb-3">
            <Icon icon="information" class="mr-3"/>
            <h4 class="eina-bold info-title">Membership Info</h4>
        </div>
        <div class="info-table">
            <table>
                <tbody>
                    <tr>
                        <td>My current plan:</td>
                        <td class="eina-bold">{{currentPlan}}</td>
                    </tr>
                    <fragment v-if="inPremium">
                        <tr>
                            <td>
                                Expires on
                            </td>
                            <td class="eina-bold">{{expirationDate}}</td>
                        </tr>
                        <tr>
                            <td>Stripe Account Email</td>
                            <td class="eina-bold">{{user.premiumPlan.customerEmail}}</td>
                        </tr>
                    </fragment>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="2">
                            <div class="note-alert">
                                <span class="eina-bold">NOTE:</span>
                                <p>
                                    <span v-if="inPremium">You can prolong your membership by visiting</span> 
                                    <span v-else>You can upgrade your membership by visiting</span> 
                                    <router-link 
                                        class="c1"
                                        :to="'/pricing'" 
                                    >
                                        Pricing page.
                                    </router-link>
                                </p>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </section> 
</template>

<script>
import Icon from '../../../components/Theme/Icon'
import Button from '../../../components/Theme/Button'
import {mapState, mapGetters} from 'vuex'
import {dates} from '../../../core/filters'
import CheckoutButton from '../../../components/CheckoutButton'
import {message} from 'ant-design-vue'
import moment from 'moment'

export default {
    name: 'Information',
    components: {
        Icon,
        Button,
        CheckoutButton
    },
    filters: {
        secondsToDateMonthDay: dates.secondsToDateMonthDay
    },
    mounted(){
        if(this.$route.query['payment-updated']) {
            message.success('Payment details are successfully updated')
        }
    },
    computed: {
        ...mapState([ 
            'user'
        ]),
        ...mapGetters(['inPremium']),
        expirationDate(){
            return this.user.premiumPlan && this.$options.filters.secondsToDateMonthDay(this.user.premiumPlan.endDate.seconds)
        },
        currentPlan(){
            return this.user.premiumPlan && this.user.premiumPlan.status === 'active' ? 'Premium' : 'Basic'
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables.scss';
.card {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    max-width: 590px;
    padding: 20px;
}

.info-title {
    font-size: 24px;
}

.info-table {
    padding: 15px;
    table {
        width: 100%;
    }

    td {
        padding: 15px 0;

        
    }

    tbody {
        font-size: 16px;

        tr {
            border-top: 1px solid #D6DDE3;
        }

        tr:last-child {
            border-bottom: 1px solid #D6DDE3;
        }
    }

    
    tfoot {
        td {
            padding-bottom: 0;
            padding-top: 20px;
            font-size: 14px;
        }

        .note-alert {
            padding: 12px 16px;
            background: #F4F7FA;
            border-radius: 8px;

            a:hover {
                color: $c1;
            }
        }
    }

    .subscr-status {
        text-transform: capitalize;

        &.status-active {
            color: $c2;
        }

        &.status-expired {
            color: $c5;
        }
    }

    .status-description {
        color: #333;
        text-transform:none;
        font-weight: bold;
    }

    .info-sign {
        text-transform: none;
        color: #ffffff;
        font-size: 13px;
        background: #333333a1;
        display: block;
        width: 16px;
        height: 16px;
        line-height: 18px;
        text-align: center;
        margin-left: 10px;
        border-radius: 50%;
        cursor: pointer;
    }
}
</style>